// Shared helpers for CMS-driven listing pages (destinations/experiences/itineraries).
// Presentation-only: sorting/pagination/intro/CTA. Never alters query logic or records.

const stripTags = (h) => String(h || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

export const validHref = (h) => {
  h = String(h || "").trim();
  return !!h && (h.startsWith("/") || h.startsWith("http://") || h.startsWith("https://") || h.startsWith("mailto:") || h.startsWith("tel:") || h.startsWith("#"));
};

// Deterministic, case-insensitive title sort; newest uses a legitimate existing date only.
export function sortItems(items, sort, nameKey = "title") {
  const arr = [...(items || [])];
  if (sort === "title") {
    return arr.sort((a, b) => String(a[nameKey] || "").toLowerCase().localeCompare(String(b[nameKey] || "").toLowerCase()));
  }
  if (sort === "newest") {
    const dateOf = (x) => x.updated_at || x.created_at || x.published_at || null;
    if (!arr.some(dateOf)) return arr; // no legitimate date available → preserve default order (never fabricate)
    return arr.sort((a, b) => new Date(dateOf(b) || 0) - new Date(dateOf(a) || 0));
  }
  return arr; // default → preserve master-record order
}

// Returns a usable intro CTA or null (mirrors backend stripping of invalid/disabled CTAs).
export function listingCta(cfg) {
  const c = cfg && cfg.cta;
  if (!c || c.enabled === false) return null;
  const label = String(c.label || "").trim();
  const href = String(c.href || "").trim();
  if (!label || !validHref(href)) return null;
  return { label, href };
}

export function hasIntro(cfg) {
  if (!cfg) return false;
  return !!(String(cfg.intro_overline || "").trim() || String(cfg.intro_heading || "").trim() || stripTags(cfg.intro_body));
}
